import type {ImageField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'

export type TimelineCardProps = {
  title: string
  description: string
  image: ImageField
}

export const TimelineCard = ({title, description, image}: TimelineCardProps) => (
  <div className="flex w-[340px] shrink-0 snap-start flex-col gap-6 overflow-hidden rounded-lg border border-moss-black/10 bg-moss-white pt-8 md:w-[580px]">
    <div className="flex flex-col gap-4 px-8">
      {title && <h3 className="font-main text-24 font-medium leading-8 text-moss-black">{title}</h3>}
      {description && <p className="font-main text-18 font-normal leading-6 text-moss-grey-400">{description}</p>}
    </div>
    {isFilled.image(image) && (
      <div className="relative h-80 overflow-hidden">
        <PrismicNextImage field={image} fill className="object-cover" />
      </div>
    )}
  </div>
)
